import Pagination from '../../../preliquidacion/components/pagination/pagination';

const PanelPagos = props => {
  const numberWithDots = value => (value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const maxItems = 10;
  const currentPage = props.pager.currentPage - 1;
  const initialItem = currentPage * maxItems;
  const lastItem = initialItem + maxItems
  const paylistData = props.paylistData
    .filter(pay => pay.isSelected)
    .slice(initialItem, lastItem);
  return (
    <div className="payment-panel" id="payment-panel">
      {paylistData.length ?
        <div className="form-group">
          <div className="accordion-container">
            <PanelGroup id='accordion-group-payment-panel'>
              <Panel id='pending-payment-people' expanded={props.open}>
                <Panel.Heading onClick={props.onSelectKey} >
                  <Panel.Title toggle>
                    <div className="accordion-title-container">
                      <div className="accordion-title-left inl-blk">
                        <span className={`accordion-title-name ${props.open ? 'orange-title' : 'black-title'}`}>{i18next.t('tituloPanelPago')}</span>
                      </div>
                      <div className="accordion-title-right inl-blk ">
                        <i className={`${props.open ? 'fas fa-chevron-circle-up orange-circle' : 'fas fa-chevron-circle-down black-circle'}`}></i>
                      </div>
                    </div>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Collapse>
                  <Panel.Body>
                    {
                      paylistData
                        .map(pay => (
                          <div className="payment-month-container">
                            <p className="payment-month-item inl-blk month-name">{pay.monthName}</p>
                            <p className="payment-month-item pull-right">
                              <span className="payment-fee">{'$' + numberWithDots(pay.amountFee)}</span>
                              <span className="inl-blk delete-icon" onClick={e => props.handleChecked({ ...e, value: false }, false, pay.index)} >
                                <i className="fa fa-trash" />
                              </span>
                            </p>
                            <div className="clearfix"></div>
                          </div>
                        ))
                    }
                    {
                      props.pager.totalPages == 1 ? '' :
                        <Pagination pager={props.pager} setPage={props.setPage} />
                    }
                  </Panel.Body>
                </Panel.Collapse>
              </Panel>
            </PanelGroup>
            <div className="payment-total text-center">
              <p>
                <span className="month-name">Valor total a pagar: </span>
                <span className="payment-fee pull-right">${numberWithDots(paylistData.reduce((acum, act) => acum + act.amountFee, 0))}</span>
              </p>
              <div className="clearfix">
                <button className="btn btn-default" onClick={(e) => props.sendInfoToPaymentPage(e, paylistData)}>
                  {i18next.t("pagarEnLinea")}
                </button>
              </div>
            </div>
          </div>
        </div>
        :
        <div className="accordion-title-container">
          <div className="accordion-title-left inl-blk">
            <div className="image-container text-center">
              <p className='empty-title'>{i18next.t('tituloPanelPagoVacio') || 'No tienes pagos seleccionados'}</p>
              <img src="/salud/Style%20Library/images/no_elements_table.png" />
            </div>
          </div>
        </div>
      }
    </div>
  );
}

const PanelGroup = ReactBootstrap.PanelGroup;
const Panel = ReactBootstrap.Panel;

export default PanelPagos;